import http from "../../../../../../../core/utils/apis/skillApi";

const BASE = '/evaluation-sections';

export const EvaluationSectionService = {
  getAll: () => http.get(BASE),

  getById: (id) => http.get(`${BASE}/${id}`),

  create: (data) => http.post(BASE, data),

  update: (id, data) => http.patch(`${BASE}/${id}`, data),

  remove: (id) => http.delete(`${BASE}/${id}`),
};
